// extracted by css-extract-rspack-plugin
export default {"eventRow":"event-row-module__eventRow__xtIwl","failedLoadRow":"event-row-module__failedLoadRow__mi0hS","rowInlineAvatars":"event-row-module__rowInlineAvatars__svO0Y"};